import { render } from "./CoursesSection.vue?vue&type=template&id=f9139410&scoped=true"
import script from "./CoursesSection.vue?vue&type=script&lang=js"
export * from "./CoursesSection.vue?vue&type=script&lang=js"

import "./CoursesSection.vue?vue&type=style&index=0&id=f9139410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9139410"]])

export default __exports__